function isOnScreen(s) {
  if (s.length != 0) {
      var e = jQuery(window),
          t = e.scrollTop(),
          o = e.height(),
          l = t + o,
          n = jQuery(s),
          i = n.offset().top,
          r = n.height(),
          a = i + r;
      return (i >= t && i < l) || (a > t && a <= l) || (r > o && i <= t && a >= l);
  }
}


$(document).ready(function(){ 
  
  // Product quantity add remove start here

    if($('.js-quantity-button-add').length > 0) {
        $('.js-quantity-button-add').click(function () {
            if ($(this).prev().val() < 10) {
            $(this).prev().val(+$(this).prev().val() + 1);
            }
        });
    }
    
    if($('.js-quantity-button-minus').length > 0) {
        $('.js-quantity-button-minus').click(function () {
            if ($(this).next().val() > 1) {
            if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
            }
        });
    }
    
    // Product quantity add remove end here

  isOnScreen($(".non-sticky-atc-button").eq(0)) ||
  isOnScreen($(".non-sticky-atc-button").eq(1)) ||
  isOnScreen($(".non-sticky-atc-button").eq(2)) ||
  isOnScreen($(".non-sticky-atc-button").eq(3)) ||
  isOnScreen($(".non-sticky-atc-button").eq(4)) ||
  isOnScreen($("#footer"))
      ? $(".sticky-atc-button").fadeOut(100)
      : $(".sticky-atc-button").fadeIn(100),
      $(window).on("scroll", function () {
          isOnScreen($(".non-sticky-atc-button").eq(0)) ||
          isOnScreen($(".non-sticky-atc-button").eq(1)) ||
          isOnScreen($(".non-sticky-atc-button").eq(2)) ||
          isOnScreen($(".non-sticky-atc-button").eq(3)) ||
          isOnScreen($(".non-sticky-atc-button").eq(4)) ||
          isOnScreen($("#footer"))
              ? $(".sticky-atc-button").fadeOut(10)
              : $(".sticky-atc-button").fadeIn(10);
      });


    // ============ Product Slider ==============

    if($('.js-product-details-slider').length > 0) {
        $('.js-product-details-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true, //NTG - 22 July 2023 - changed to true
            fade: true,
            lazyLoad: 'progressive',
            asNavFor: '.js-product-details-nav-slider'
        });
    }
    if($('.js-product-details-nav-slider').length > 0) {
        $('.js-product-details-nav-slider').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            vertical: false, //NTG - 22 July 2023 - changed to false
            verticalSwiping: false,
            asNavFor: '.js-product-details-slider',
            dots: false,
            arrows: false,
            lazyLoad: 'progressive',
            focusOnSelect: true,
            infinite: false,
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    vertical: false,
                    verticalSwiping: false
                  }
                },
              ]         
        });
    }
  if ($('.js-product-details-nav-slider').length > 0) {    
    var test = $(".js-product-details-nav-slider .product-details__nav-item").length;    
  }
  if (test <= 6) {
    $(".js-product-details-nav-slider").addClass("show-six-item");
  }else{
    $(".js-product-details-nav-slider").removeClass("show-six-item");
  }

// ============ Product Slider Secondary - Tenants ==============

const tenantSliders = document.querySelectorAll('.js-product-details-slider-secondary')
tenantSliders.forEach(slider => {
  const wrapper = slider.closest('.product-details__slider-wrap')
  const sliderNav = wrapper.querySelector('.js-product-details-nav-slider-secondary')
  $(slider).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    lazyLoad: 'progressive',
    asNavFor: sliderNav
  });

  $(sliderNav).slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: false,
    verticalSwiping: false,
    asNavFor: slider,
    dots: false,
    arrows: false,
    lazyLoad: 'progressive',
    focusOnSelect: true,
    responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            vertical: false,
            verticalSwiping: false
          }
        },
      ]         
  });


  // if ($('.js-product-details-nav-slider-secondary').length > 0) {    
  //   var test = $(".js-product-details-nav-slider-secondary .product-details__nav-item").length;    
  //   }
  //   if (test <= 6) {
  //   $(".js-product-details-nav-slider-secondary").addClass("show-six-item");
  //   }else{
  //   $(".js-product-details-nav-slider-secondary").removeClass("show-six-item");
  //   }

});


   jQuery('.scrollTo').click(function(e) {
         var jump = jQuery(this).attr('href');
        var new_position = jQuery(jump).offset();
        var scroll = 0;
        jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 1000, function(){
            var new_position = jQuery(jump).offset();
             jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 1000);
         });
         e.preventDefault();
     });
  
    // Client Slider

    if($('.js-client-slider').length > 0) {
      $('.js-client-slider').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          lazyLoad: 'progressive',
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1
              }
            },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              },
            ]         
      });
    }


    // Product quantity add remove start here

    // if($('.js-product-quantity-add').length > 0) {
    //     $('.js-product-quantity-add').click(function () {
    //         if ($(this).prev().val() < 10) {
    //         $(this).prev().val(+$(this).prev().val() + 1);
    //         }
    //     });
    // }
    
    // if($('.js-product-quantity-remove').length > 0) {
    //     $('.js-product-quantity-remove').click(function () {
    //         if ($(this).next().val() > 1) {
    //         if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
    //         }
    //     });
    // }
    
    // Product quantity add remove end here


    //collection cart update  end


    // ============ What's Included Slider ==============

    // if($('.js-whats-included-slider').length > 0) {
    //     $('.js-whats-included-slider').slick({
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         arrows: true,
    //         dots:true,
    //         lazyLoad: 'progressive'
    //     });
    // }

    
});


// FAQ Accordian Start


var accordion = (function () {
  var $accordion = $(".js-accordion");
  var $accordion_header = $accordion.find(".js-accordion-header");
  var $accordion_item = $(".js-accordion-item");

  // default settings
  var settings = {
    // animation speed
    speed: 400,

    // close all other accordion items if true
    oneOpen: false
  };

  return {
    // pass configurable object literal
    init: function ($settings) {
      $accordion_header.on("click", function () {
        accordion.toggle($(this));
      });

      $.extend(settings, $settings);

      // ensure only one accordion is active if oneOpen is true
      if (settings.oneOpen && $(".js-accordion-item.active").length > 1) {
        $(".js-accordion-item.active:not(:first)").removeClass("active");
      }

      // reveal the active accordion bodies
      $(".js-accordion-item.active").find("> .js-accordion-body").show();
    },
    toggle: function ($this) {
      if (
        settings.oneOpen &&
        $this[0] !=
          $this
            .closest(".js-accordion")
            .find("> .js-accordion-item.active > .js-accordion-header")[0]
      ) {
        $this
          .closest(".js-accordion")
          .find("> .js-accordion-item")
          .removeClass("active")
          .find(".js-accordion-body")
          .slideUp();
        // Added by Aman
        $this.closest(".js-faq-row").find(".js-accordion-item").removeClass("active").find(".js-accordion-body").slideUp();
      }
      


      // show/hide the clicked accordion item
      $this.closest(".js-accordion-item").toggleClass("active");
      
      $this.next().stop().slideToggle(settings.speed);
     
    }
  };
})();

$(document).ready(function () {
  accordion.init({ speed: 300, oneOpen: true });
});

// Save Button Text
const btnText = document.querySelector(`.js-cw-product-page-form .js-pdp-atc .js_span`)

// FAQ Accordian End
$(document).ready(function () {
    $('#js_reg_price').show();
    $('.js-price').hide();
    $(document).on('change',`.js-cw-product-page-form [data-option-1] input, .js-cw-product-page-form [data-option-2] input,.js-cw-product-page-form [data-option-3] input`,function(e){
		let option1 = option2 = option3 = null;
		if($(`.js-cw-product-page-form [data-option-1]`).length > 0) {
			option1 = $(`.js-cw-product-page-form [data-option-1] input:checked`).val();
		}
		if($(`.js-cw-product-page-form [data-option-2]`).length > 0) {
			option2 = $(`.js-cw-product-page-form [data-option-2] input:checked`).val();
		}
		if($(`.js-cw-product-page-form [data-option-3]`).length > 0) {
			option3 = $(`.js-cw-product-page-form [data-option-3] input:checked`).val();
		}
		let variant_id = null;
		let current_selected_option = null;
		if(option2 == null & option3 == null) {
            current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1="${option1}"]`);
            variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1="${option1}"]`).val();
		}
		if(option2 != null & option3 == null) {
              current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1="${option1}"][data-option2="${option2}"]`);
              variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1="${option1}"][data-option2="${option2}"]`).val();
		}
		if(option2 != null & option3 != null) {
              current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1="${option1}"][data-option2="${option2}"][data-option3="${option3}"]`);
              variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1="${option1}"][data-option2="${option2}"][data-option3="${option3}"]`).val();
		}
		if(variant_id == null) {
			$(`.js-cw-product-page-form .product_page_atc`).addClass('soldout');
			$(`.js-cw-product-page-form .product_page_atc span`).text("Unavailable");
			return true;
		}
      // Call Custom Variant Id
      // $('.product-details__btn-qty a.button.js-pdp-atc').attr('data-variant', variantId);
        // console.log(variantId)
      
		let price = $(current_selected_option).attr('data-price');
		let compare_at_price = $(current_selected_option).attr('data-compareat-price');
		let discount = $(current_selected_option).attr('data-discount');
		let image_src = $(current_selected_option).attr('data-image');
        let currentSubPrice = document.querySelector('.product-details__offer .js_sub_price');
        let subscribe_price = $(current_selected_option).attr('data-packsubplan_discount_price1');
        let after_pay = $(current_selected_option).attr('data-after');
		let save = $(current_selected_option).attr('data-save');
		let is_available = $(current_selected_option).attr('data-available');
		$(`.js-cw-product-page-form select.actual-variants`).val(variant_id).trigger('change');
		$(`#js-compare-price`).html(compare_at_price);
        if($("#js_clearpay") > 0){
          $(`#js_clearpay`).attr('data-amount', after_pay);
          $(`#js_clearpay1`).attr('data-amount', after_pay);
        }
        $(`.js-price`).text(price);
        $('.js_sub_price').text(subscribe_price);
        $('#js_sub_price').text(subscribe_price);
        $(`.js_save_price`).text(' ' + save);
        $('#js_reg_price').hide();
        $('.js-price').show();
        let csRadioInput = document.getElementById('product-details-offer2');
        if (csRadioInput.checked) {
          $('.product-details__price').addClass('subscription-option-is-selected');
        }else{
          $('.product-details__price').removeClass('subscription-option-is-selected');
        }
  		if(is_available == 'true') {
			 
			$(`.js-cw-product-page-form .js-pdp-atc`).removeClass('soldout');
			$(`.js-cw-product-page-form .js-pdp-atc .js_span`).text(`${btnText.textContent}`);
            
		} else {
		    $(`.js-cw-product-page-form .js-pdp-atc`).addClass('soldout');
			$(`.js-cw-product-page-form .js-pdp-atc .span`).text("Soldout");
		}
		let current_position = null;
        const cpdEvent = new CustomEvent("change:cpd", {
          bubbles: true,
        });
      
        document.dispatchEvent(cpdEvent)
  
        setTimeout(function() {
      		cw.variants.forEach((em,ix) => {
      			if( em.id == variant_id && em.featured_image != null ) {
      				current_position = em.featured_image.position - 1;
      				$(`.probig`).slick('slickGoTo',current_position);
      			}
      		});
          }, 800);
		// var newurl =
  //       window.location.protocol +
  //       '//' +
  //       window.location.host +
  //       window.location.pathname +
  //       '?variant=' +
  //       variant_id;
  //     	window.history.replaceState({ path: newurl }, '', newurl);
		/*
		console.log(variant_id);
		console.log(price);
		console.log(compare_at_price);
		console.log(discount);
		console.log(image_src);
		console.log(save);
		*/
	});

$(document).on(`click`,`.js-cw-product-page-form .js-pdp-atc`,function(e){
		e.preventDefault();
  
		// let items = Array();
		// let form_data_array = $(`.js-cw-product-page-form`).serializeArray();
        let vid = $('[name="id"]').val();
        let qty = $('.js_qty').val();
        let items = [];
   
    let selling_plan_allocation = $(".selling_plan_allocation").val();
		// let item = {};
         
        if($('[name="product-details-offer"]:checked').val() == "otp") {
          //OTP
       items.push({ id: vid, quantity: qty });
      } else {
          //SUB
          items.push({ id: vid, quantity: qty, selling_plan: selling_plan_allocation });
      }

      // ✅ Check for optional free product
      const freeProductId = $('[name="free_product_id"]').val();
      if (freeProductId) {
        items.push({ id: freeProductId, quantity: 1 });
      }

      if($(this).hasClass('gPreorderBtn')){
        const form = $(this).closest('.singleProductPreOrderForm');
        items = items || {};
        items.properties = {
          '_is_preorder': form.find('.gPreorderProperty').val(),
          '_preorder_locale': form.find('.gPreorderLocale').val()
        }
      }

      console.log(items)
  
		/*$.ajax({
			url : "/cart/add.js",
			data : items,
			method : "POST",
			dataType : "JSON",
			success  : function(data) {
			  // window.location = "/checkout";
              console.log('Product added', data);
              jQuery.getJSON('/cart.js', function (cart, textStatus) {
                $('.cart-count-bubble span').text(cart.item_count)
              });
			},
			error:function(data){
				window.alert(data.responseJSON.description);
			}
		});*/
        $.ajax({
  url: "/cart/add.js",
  data: JSON.stringify({ items: items }), // ✅ Correct format
  method: "POST",
  dataType: "json",
  contentType: "application/json", // ✅ Required for JSON body
  success: function (data) {
    console.log('Product added', data);
    $.getJSON('/cart.js', function (cart) {
      $('.cart-count-bubble span').text(cart.item_count);
    });
  },
  error: function (data) {
    alert(data.responseJSON?.description || 'Error adding to cart');
  }
});

	});	


});

 $(document).ready(function() {
  $(document).on('click','.js-bundle-product-atc',function(e){
    e.preventDefault();
//     debugger;
    const container = e.target.closest('.js-bundle-product-atc')
    var target = container.querySelector('.bundle-product-atc');
    let parent = $(target).parents('.package__box').eq(0);
    var variant_id = $(target).attr("data-id");
    var quantity = 1;
    let data = {};
    data.id = variant_id;
    data.quantity = 1;

    $.ajax({
      url : "/cart/add.js",
      data: data,
      method : "POST",
      dataType : "JSON",
      success : function(data) {
        jQuery.getJSON('/cart.js', function (cart, textStatus) {
      $('.cart-count-bubble span').text(cart.item_count)
            });
      	//window.location = "/checkout";
        console.log('product added')
        
      },
      error : function(data) {
		alert(data.responseJSON.description);
      }
    });
  });


   function changesubMainprice(){  
    let price = $(`[name="id"] option:selected`).attr('data-price').trim();

    let rawPrice = price.toString().replace("$","").replace(".","");
    rawPrice = parseInt(rawPrice);
    let compare_at_price = $(`[name="id"] option:selected`).attr('data-compareat-price').trim();
    let subscribe_price = $(`[name="id"] option:selected`).attr('data-packsubplan_discount_price1');
    
    $(`[data-otp-reg-price]`).text(price);
    $(`[data-otp-del-price]`).text(compare_at_price);
    $('.js_sub_price').text(subscribe_price);
    $('#js_sub_price').text(subscribe_price);
    $('.js_sub_del_price').text(subscribe_price);
    $('.js_sub_del_price').text(compare_at_price);
    if($('[name="subscription_type"]:checked').val() == "otp") {
      //OTP
      $(`.js-price`).text(price);
      $(`.js-sub-price-change`).hide();
      $(`.js-price`).show();
    } else if($('[name="subscription_type"]:checked').val() == "subscription") {
      //SUB
      $(`.js-sub-price-change`).text(subscribe_price);
      $(`.js-sub-price-change`).show();
      $(`.js-price`).hide();
       
    }
    let csRadioInputS = document.getElementById('product-details-offer2');
    if (csRadioInputS.checked) {
      $('.product-details__price').addClass('subscription-option-is-selected');
    }else{
      $('.product-details__price').removeClass('subscription-option-is-selected');
    } 
    //window.history.replaceState({ }, '', `${window.location.origin}${window.location.pathname}?variant=${$(`[name='id']`).val()}`);
  }
  $('.selling_plan_allocation').hide();
  $(document).on('change','[name="product-details-offer"]',function(e){
  
  changesubMainprice();
  if($('[name="product-details-offer"]:checked').val() == "otp") {
    
      $('.selling_plan_allocation').fadeOut(0);
    
    } else if($('[name="product-details-offer"]:checked').val() == "subscription") {
      //SUB
       $('.selling_plan_allocation').fadeIn(0);
       
    }
});

   /***Timer Js***/
      function makeTimer() {

        //		var endTime = new Date("29 April 2018 9:56:00 GMT+01:00");	
        var endTime = new Date("12 october 2022 13:00:00 GMT+01:00");
        endTime = (Date.parse(endTime) / 1000);
        console.log(endTime);

        var now = new Date();
         
        now = (Date.parse(now) / 1000);

        var timeLeft = endTime - now;

        var days = Math.floor(timeLeft / 86400);
        var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
        var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
        var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

        if (hours < "10") {
          hours = "0" + hours;
        }
        if (minutes < "10") { minutes = "0" + minutes; }
        if (seconds < "10") { seconds = "0" + seconds; }

        // $("#days").html(days + "<span>Days</span>");
        $(".hours").html(hours + " <span>hrs</span>");
        $(".minutes").html(minutes + " <span>mins</span>");
        $(".seconds").html(seconds + " <span>s</span>");		
      }

      setInterval(function () {
        makeTimer();
      }, 1000);
  });

/**
 * 
 * Combo Product Store
 * 
 */

// Get Selected Weight Option
document.addEventListener('change', e => {
  if (e.target.name !== 'option-weight') {
    return
  }

  const value = e.target.value

  // Product Options
  const allProductOptions = document.querySelectorAll('[data-product-option]')
  allProductOptions.forEach(option => {
    if (option.classList.contains('combo-hide') === false) {
      option.classList.add('combo-hide')
    }
  });

  const selector = `[data-product-option="${value}"]`
  const productOption = document.querySelector(selector)
  productOption.classList.toggle('combo-hide')

  // Product Slides
  const productSliders = document.querySelectorAll('[data-product-slide]')
  productSliders.forEach(slider => {
    if (slider.classList.contains('combo-slide-hide') === false) {
      slider.classList.add('combo-slide-hide')
    }
  })

  const slideSelector = `[data-product-slide="${value}"]`
  const productSlider = document.querySelector(slideSelector)
  productSlider.classList.toggle('combo-slide-hide')

  // // Get selected variant
  const variantWrapper = document.querySelector(`[data-product-option="${value}"]`)
  const variantInputs = variantWrapper.querySelectorAll('input[type="radio"]')
  const variantsJSON = JSON.parse(variantWrapper.querySelector('[data-variants-json]').innerHTML)
  const variantInput = e.target.closest('form').querySelector('input[name="id"]')
  const priceSelector = document.querySelector('#js_reg_price')

  variantInputs.forEach(input => {
    if (input.checked) {
      const foundVariant = variantsJSON.find(variant => {
        return variant.option1 === input.value
      })

      if (foundVariant !== undefined) {
        const id = foundVariant.id
        variantInput.value = id
        const number = (foundVariant.price) / 100
        priceSelector.textContent = new Intl.NumberFormat('en-GB', { style: 'currency', currency: window.Shopify.currency.active }).format(number)
      }
    }
  });

})

// Get Selected Variant Option
document.addEventListener('change', e => {
  if (e.target.dataset.inputOption !== 'combo') {
    return
  }

  const priceSelector = document.querySelector('#js_reg_price')
  const variantInput = e.target.closest('form').querySelector('input[name="id"]')
  const variantWrapper = e.target.closest(`[data-product-option]`)
  const variantsJSON = JSON.parse(variantWrapper.querySelector('[data-variants-json]').innerHTML)

  const value = e.target.value

  const foundVariant = variantsJSON.find(variant => {
    return variant.option1 === value
  })

  if (foundVariant !== undefined) {
    const id = foundVariant.id
    variantInput.value = id
    const number = (foundVariant.price) / 100
    priceSelector.textContent = new Intl.NumberFormat('en-GB', { style: 'currency', currency: window.Shopify.currency.active }).format(number)
  }
})